import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { DropdownMenu, renderDropdownItems } from "@air/primitive-dropdown-menu";
import { memo } from "react";
import { ASSET_DOWNLOAD_DROPDOWN_MENU_TRIGGER } from "~/constants/testIDs";
import { usePublicDownloadOptions } from "../shared/hooks/usePublicDownloadOptions";
export const PublicDownloadButton = /*#__PURE__*/ memo(()=>{
    const options = usePublicDownloadOptions();
    return /*#__PURE__*/ _jsx(DropdownMenu, {
        trigger: /*#__PURE__*/ _jsx(Button, {
            appearance: "filled",
            color: "blue",
            size: "large",
            "data-testid": ASSET_DOWNLOAD_DROPDOWN_MENU_TRIGGER,
            children: "Download"
        }),
        children: renderDropdownItems({
            options
        })
    });
});
PublicDownloadButton.displayName = "PublicDownloadButton";
